import { Subject } from 'rxjs';

export const orderGridReloadSubject = new Subject();
